import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { ImageSliderComponent } from 'src/app/components/image-slider/image-slider.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { TicketHistoryComponent } from '../../service-slide-show/ticket-history/ticket-history.component';

@Component({
  selector: 'app-keyword-slideshow',
  templateUrl: './keyword-slideshow.component.html',
  styleUrls: ['./keyword-slideshow.component.scss']
})
export class KeywordSlideshowComponent implements OnInit {

  @ViewChild('slickModal')
  slickModalView: any;
  @ViewChild('slickModal')
  slickModal: SlickCarouselComponent;
  @ViewChild("warningMessageModal") warningModal: any;
  @ViewChild('successModal')
  successModal:any;
  @ViewChild('basicModal')
  basicModal: any;

  slideShowData:any= [];
  LoaderComponent: any;
  slideShowCount:any;
  slideConfig:any;
  dropDownSettings: any = {};
  formValue;
  mode:any;
  viewCount = 1;
  slideCount = 1;
  currentSlider = 1;
  displayValues: any[] = [];
  keywordObj: any;
  allMyProfiles: any[] = [];
  aboutDataValues: any[];
  responseMessage:any="";
  isSlideShowActivated:boolean = false;
  loginData:any;
  custId:any;
  mobileNumber:any;
  modalBoolean:boolean;
  ticketId:any;


  constructor(public service: WebRequestService,
    public cookieService: CookieService,
    private loginDataStore: Data,
    public router: Router,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    public dialogRef: MatDialogRef<KeywordSlideshowComponent>) { 
    this.slideConfig =  {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      dots: false,
      autoplaySpeed: 2000,
      autoplay: false,
      infinite: false,
      lazyLoad: "ondemand",
      method: {},
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
      ],
    };
    this.dropDownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
  }

  ngOnInit(): void {
    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    })
    .catch((err) => console.error(err));
    this.formValue = this.modalData.formValue
    this.mode = this.modalData.mode
    this.displayValues = this.modalData.display
  }
  ngAfterViewInit(): void {
    this.slideConfig[
      'prevArrow'
    ] = `.slide-profile-left`;
    this.slideConfig[
      'nextArrow'
    ] = `.slide-profile-right`;

    if(this.mode === 'keywordSearch') {
      this.slideShowData = [];
      if(this.modalData.display) {
        this.LoaderComponent = '';
        this.slideShowCount = this.modalData.formValue['totalRows'];
        this.slideShowData = this.displayValues;
        this.converLakhsToCrores(this.slideShowData);
        this.keywordObj = this.modalData.reqObj
      }
    }
  }
  closeSlideShow(){
    // this.slideShowModal.hide();
    // this.closeSlideShowModal.emit('');
    this.dialogRef.close();
    this.slideShowData = [];
    this.slickModalView.ngOnDestroy();
  }
  onGoToFieldChange(event) {
    if (Number.isInteger(parseInt(event.target.value))) {
      if (event.target.value > this.viewCount) {
        this.responseMessage = "Please enter number below the view profiles count !!!"
        this.warningModal.show();
        setTimeout(() => {
          this.warningModal.hide();
        }, 5000);
      } else if (event.target.value != 0 && this.viewCount != 1) {
        this.slickModal.slickGoTo(event.target.value -1);

      }

    } else if (event.target.value != "") {
      this.responseMessage = "Please enter only numerical values !!!"
      this.warningModal.show();
      setTimeout(() => {
        this.warningModal.hide();
      }, 5000);
    }
  }
  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }
  activateSlideShow(value) {
    if (!value) {
      this.isSlideShowActivated = true;
        this.slickModal.slickPlay()
    } else {
      this.isSlideShowActivated = false;
      this.slickModal.slickPause();
    }
  }
  afterChange(e) {
    this.slideCount = e.currentSlide;
    this.currentSlider = e.currentSlide + 1
    // this.saFormInputField.nativeElement.value = "";
    if (this.slideCount === e.currentSlide && this.slideCount < this.slideShowCount) {

      this.resetNextValues();
    } else if (e.currentSlide < this.viewCount) {
      this.resetPreviousValues(e.currentSlide);
    }
  }

  beforeChange(e) {
    // if(e.currentSlide){
    //   this.viewCount = this.slideCount;
    // }
  }
  resetNextValues() {
    if (this.slideCount === this.slideShowData.length - 4 && this.slideShowData.length < this.slideShowCount) {
      this.callNextValues();
    };

    // if (this.slideCount >= this.viewCount) {
    //   this.viewCount = this.viewCount + 1;
    // }
    if (this.currentSlider > this.viewCount) {
      this.viewCount = this.viewCount + 1;
    }
    // if (this.viewCount > this.slideCount) {
    //   this.viewCount = this.viewCount- 1;
    // }

  }

  resetPreviousValues(currentSlide) {
    this.slideCount = currentSlide;
    this.viewCount = this.viewCount - 1;
  }

  callNextValues() {
    if(this.mode === 'keywordSearch') {
      this.keywordObj['StartIndex'] = this.keywordObj['EndIndex'] + 1;
      this.keywordObj['EndIndex'] = this.keywordObj['EndIndex'] + 30;
      // this.slideShowData = [];
      this.LoaderComponent = LoaderComponent;
      this.service.keyWordSearch(this.keywordObj).then((res) => {
        if (res['statusCode'] === 200) {
          let count = res['result'].length;
          for (let i = 0; i < count; i++) {
            this.slideShowData.push(res['result'][i])
            this.LoaderComponent = '';
          }
          this.converLakhsToCrores(this.slideShowData);
          // this.slideShowData = this.allMyProfiles;
        } else {
          this.LoaderComponent = '';
        }
      })
    }   
  }
  copyProfileId(profileId){
    console.log('>>>',profileId);
    const el = document.createElement('textarea');
    el.value = profileId;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
  navigateToViewProfileByProfileId(id){
    window.open(`/viewProfile;profileID=${id};format=${this.loginData.formatAccess}`, '_blank');
  }
  getAssignTktColour(element) {
    if (element === 1) {
      return 'green'
    } else if (element === 2) {
      return 'blue'
    } else if (element === 0) {
      return 'red'
    } else {
      return 'red'
    }
  }
  getProfileTypeWithProfileID(profile) {
    if (profile['subscriptionServiceTypeId'] === 601 || profile['subscriptionServiceTypeId'] === "601") {
      return profile['profileID'] + '- R'
    } else if (profile['subscriptionServiceTypeId'] === 602 || profile['subscriptionServiceTypeId'] === "602") {
      return profile['profileID'] + '- A'
    } else if (profile['subscriptionServiceTypeId'] === 603 || profile['subscriptionServiceTypeId'] === "603") {
      const grade = profile['confidentialGrade'] != null ? ('- C' + profile['confidentialGrade']) : '- C';
      return profile['profileID'] + grade
    } else if (profile['subscriptionServiceTypeId'] === 604 || profile['subscriptionServiceTypeId'] === "604") {
      return profile['isSuperHighConfidential'] ? profile['profileID'] + '- NX' : profile['profileID'] + '- SC'
    } else if (profile['subscriptionServiceTypeId'] === 600 || profile['subscriptionServiceTypeId'] === "600") {
      return profile['profileID']
    } else {
      return profile['profileID']
    }
  }
  getUserPhotoGal(isPhotoAvailable, Id) {
    if (!(isPhotoAvailable.includes('noimages') && !(isPhotoAvailable.includes('Password-Protected') && Id))) {
      const custID = Id;
      let dialogRef = this.dialog.open(ImageSliderComponent, {
        width: '500px',
        // height: '551px',
        data: { custID: custID}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }
  }
  naviagteToHoroscope(horoimg) {
    if (horoimg!= null) {
      window.open(`${horoimg}`, '_blank');

    }
  }
  photoRequest(profileId){
    this.LoaderComponent = LoaderComponent;
    this.service.editViewPhotoRequest(profileId,this.loginData['employeeID']).then((response)=>{
      if(response['statusCode']===200){
      this.LoaderComponent = ""
        // this.basicModal.hide();
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else{
        this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
  }
  showDetails(profile) {
    this.responseMessage = profile;
    this.successModal.show();
  }
  verifyEmail(id) {
    this.LoaderComponent = LoaderComponent;
    this.service.verifyTicketEmail(id).then((response)=>{
      if(response['statusCode']===200){
        this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else{
        this.LoaderComponent = "";
      }
    })
   }
   verifyMobileNumber(id,mobileNumber){
    this.LoaderComponent = LoaderComponent;
    this.custId = id;
    this.mobileNumber =  mobileNumber;
    this.service.verifyMobileNumber(this.custId,3).then((response)=>{
      if(response['statusCode']===200){
       this.LoaderComponent = "";
      //  this.basicModal.show();
      } else{
       this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
         this.successModal.hide();
       }, 5000);
      }
    })
  }
  getOfficePurposeData(id) {
    let finalObject = {
      "custID": id,
      "aboutProfile": "",
      "id": null,
      "flag": 0
    }
    this.LoaderComponent = LoaderComponent;
    this.aboutDataValues = [];
    this.service.getEditViewOfficeAboutDetails(finalObject).then((response) => {
      if (response['statusCode'] === 200) {
        this.LoaderComponent = "";
        this.aboutDataValues = response['result'];
        console.log(this.aboutDataValues)
        if(this.aboutDataValues.length>0){
          const dialogRef1 = this.dialog.open(TicketHistoryComponent, {
            width: '800px',
            data: [{mainData:this.aboutDataValues, isOffice: true}]
          })
        }else{
          const dialogRef1 = this.dialog.open(TicketHistoryComponent, {
            width: '250px',
            data: [{mainData:this.aboutDataValues, isOffice: true}]
          })
        }
       
      } else {
        this.LoaderComponent = "";

      }
    })
  }
  forgotPassword(profileId){
    this.LoaderComponent = LoaderComponent;
    this.service.editViewForgotPassword(profileId).then((response)=>{
      if(response['statusCode']===200){
        this.LoaderComponent = ""
          this.basicModal.hide();
          this.responseMessage = response['message'];
          this.successModal.show();
          setTimeout(() => {
            this.successModal.hide();
          }, 5000);
        } else{
          this.LoaderComponent = "";
  
        }
    })

  }
  navigateToPaymentPage(profileId){
    window.open(`/paymentDetails;id=${profileId}`,'_blank');

  }

  navigateToCommunicationLog(id){
    window.open(`/communicationLog;id=${id}`, '_blank');
  }
  viewMarketingTicket(ticketId){
    this.modalBoolean=false;
    this.ticketId=""
    if(ticketId!=null){
      setTimeout(()=>{
        this.modalBoolean=true;
        this.ticketId = ticketId;
      })
    }
  }

  converLakhsToCrores(records){
    for(let record of records){
      let lakhs = record.property; 
      if(Number(lakhs) > 0)
        record.property = this.propertyLakhsToCroresConversion(record.property);
    }
  }

  propertyLakhsToCroresConversion(lakhsValue){ 
    let tempPropertyValue: number = lakhsValue;
    let propertyString: any;
    if(tempPropertyValue < 100){
      if(tempPropertyValue < 2)
         propertyString =  tempPropertyValue+' Lakh';
      else
        propertyString =  tempPropertyValue+' Lakhs';
    }      
    else{
      let covertedValue = tempPropertyValue / 100;
      if(covertedValue < 2){
        propertyString = covertedValue+' Crore';
      }
      else
        propertyString = covertedValue+' Crores';
    }
    return propertyString
  }

}
